import { Card, CardContent } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import { serverUrl } from 'global/variable'
import React from 'react'

const UserManual = () => {
    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <iframe width='100%' height={700} title="Pdf" src={
                            serverUrl + '/usermanual/adminopd.pdf'
                        } />
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default UserManual